import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class AccountAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Accounts';

  /**
   * Lấy danh sách tài khoản
   * TPNAM 04.07.2022
   */
  getListAccountNumber(param) {
    let request = {
      url: this.getAPIUrl() + '/accountNumber',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy tất cả danh sách tài khoản
   * lttuan1 - 7.10.2022
   * @param {} param
   * @returns
   */
  getAllAccountNumber(param) {
    let request = {
      url: this.getAPIUrl() + '/getAllAccountNumber',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Thực hiện chuyển tài khoản
   * nthien4 15.07.2022
   * @returns
   */
  async changeAccount(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/changeAccount',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện chuyển tài khoản
   * HQMINH 06.09.2022
   */
  async getListChildAccount(parentNumber) {
    let request = {
      url: this.getAPIUrl() + '/getListChildAccount',
      data: { parentNumber },
    };

    return await httpClient.getAsync(request);
  }

  /** Lấy danh sách tài khoản cha + con theo mã cha
   * @returns
   */
  async getList(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }
  /** Lấy thông tin tài khoản theo mã
   * @returns
   */
  async getAccountDetail(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/getAccountDetail/${param}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu danh mục tài khoản
   * NTLOC 11.07.2022
   */
  async updateTranferAccountData(payload) {
    let request = {
      url: this.getAPIUrl() + '/tranferAccountData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Thêm mới tài khoản khi active trên grid
   * NTLOC 10/01/2023
   */
  getNewData(payload) {
    let request = {
      url: this.getAPIUrl() + '/newData',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
   /**
   * lấy số dư tạm ứng
   * @returns 
   * NNLINH 10.05.2023
   */
    async getAdvanceBalance(param){
      let apiUrl = this.getAPIUrl();
      let request = {
        url: apiUrl + '/AdvanceBalance',
        data: param,
      };
  
      return await httpClient.postAsync(request);
    }

  /**
   * Lấy thông tin lỗi kiểm tra phát sinh của nhiều tài khoản
   * dtnga3 (12.03.2024)
   * @param {} param
   * @returns
   */
  getAriseErrors(param) {
    let request = {
      url: this.getAPIUrl() + '/ariseErrors',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy tài khoản con chi tiết đầu tiên
   * dtnga3 (17.05.2024)
   */
  getFirstDetailAccount(param) {
    let request = {
      url: this.getAPIUrl() + '/firstDetailAccount',
      data: param,
    };

    return httpClient.getAsync(request);
  }
}

export default new AccountAPI();
